var render = function render(){var _vm=this,_c=_vm._self._c;return _c('course-video-uploader',{attrs:{"value":_vm.video,"isDragging":_vm.isDragging,"showSettingPreview":_vm.showSettingPreview},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }